import * as React from 'react'

const CueExplanation = (props: any) => (
  <div className="cue-explanation" id="cue-explanation" lang={props.languageLocale}>
    {props.text}
  </div>
)

export { CueExplanation }
